import { NgModule } from "@angular/core"
import { CommonModule } from "@angular/common"
import { PagesRoutingModule } from "./pages-routing.module"
import { PagesComponent } from "./pages.component"
import { PartialsModule } from "../shared/partials.module"
import {
	MatInputModule,
	MatCardModule,
	MatTableModule,
	MatButtonModule,
	MatPaginatorModule,
	MatSortModule,
	MatTooltipModule,
	MatProgressSpinnerModule,
	MatAutocompleteModule,
	MatSelectModule
} from "@angular/material"
import { TranslateModule } from "@ngx-translate/core"
import { ReactiveFormsModule } from "@angular/forms"
import { MaintenanceComponent } from "./maintenance/maintenance.component"
import { NetworkCoverageComponent } from "./network-coverage/network-coverage.component"

@NgModule({
	declarations: [PagesComponent, MaintenanceComponent, NetworkCoverageComponent],
	imports: [
		CommonModule,
		PagesRoutingModule,
		PartialsModule,
		MatCardModule,
		MatInputModule,
		MatTableModule,
		MatButtonModule,
		MatPaginatorModule,
		MatSortModule,
		MatTooltipModule,
		MatProgressSpinnerModule,
		TranslateModule,
		ReactiveFormsModule,
		MatAutocompleteModule,
		MatSelectModule
	],
	exports: [PagesComponent, PartialsModule]
})
export class PagesModule {}
